"use strict";

require("../../style/index.less");

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/carousel/style/index.js
// module id = 138
// module chunks = 6